import { render, staticRenderFns } from "./MessageBoardList.vue?vue&type=template&id=134f48e8&"
import script from "./MessageBoardList.vue?vue&type=script&lang=js&"
export * from "./MessageBoardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports